// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { generatePaddingStyles } from "@conklin/App/EditorTemplates/PaddingField";
import { haveQuestionsStyles } from "@conklin/App/Widgets/Common/HaveQuestions";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { avoidBreakInsidePrintElement, linkArrowStyle } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

haveQuestionsStyles.wrapper = {
    container: {
        css: css`
            flex-direction: column;
            ${({ padding }: any) =>
                padding &&
                css`
                    ${generatePaddingStyles(padding)}
                `};
            ${avoidBreakInsidePrintElement}
        `,
    },
};

haveQuestionsStyles.link = linkArrowStyle("small");

haveQuestionsStyles.linkWithoutArrow = {
    typographyProps: {
        size: 14,
        weight: fontConfig.weight.bold,
        css: css`
            line-height: 22px;
        `,
    },
};

haveQuestionsStyles.description = {
    size: 14,
    lineHeight: "22px",
    forwardAs: "p",
    css: css`
        line-height: 22px;
        margin-bottom: 16px;
    `,
};
